<template>
  <el-form :model="form1" ref="form1" :rules="rules1">
    <el-row>
      <el-col :span="8">
        <el-form-item prop="userId" class="header-name" label-width="14em" label="得意先コード：">
          <el-input v-model="form1.clientId" placeholder="" style="width: 20em"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="7">
        <el-form-item prop="company_name" class="header-name" label-width="5em" label="会社名：">
          <el-input v-model="form1.company_name" placeholder="" style="width: 20em"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="9">
        <el-button type="primary" icon="el-icon-search" @click.native.prevent="search('form1')">検索</el-button>
        <el-button type="primary" :loading="loading" @click.native.prevent="excle('form1')">Excel出力</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-form-item prop="number" class="header-name" label-width="14em" label="電話番号（ハイフン不要）：">
        <el-input v-model="form1.number" placeholder="" style="width: 20em" id="tel"></el-input>
      </el-form-item>
    </el-row>
    <el-table
      :data="tableData"
      border
      height = "660"
      style="width:100%">
      <el-table-column
        prop="client_id"
        width="253"
        align="center"
        label="得意先コード">
      </el-table-column>
      <el-table-column
        prop="company_name"
        label="会社名"
        show-overflow-tooltip
        align="center"
        width="253">
      </el-table-column>
      <el-table-column
        prop="name"
        label="担当者"
        align="center"
        show-overflow-tooltip
        width="253">
      </el-table-column>
      <el-table-column
        prop="mail_address"
        label="メールアドレス"
        align="center"
        show-overflow-tooltip
        width="253">
      </el-table-column>
      <el-table-column
        prop="tel"
        label="電話番号"
        show-overflow-tooltip
        width="253"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="sousa"
        label="操作"
        align="center"
        show-overflow-tooltip
        width="253">
        <template slot-scope="scope">
          <el-row>
        　　<el-col :span="12">
              <el-button type="primary" icon="el-icon-edit" circle
                         @click.native.prevent="handleEdit(scope.$index, scope.row)"></el-button>
            </el-col>
            <el-col :span="8"><el-button type="danger" icon="el-icon-delete" circle @click.native.prevent="handleDelete(scope.$index, scope.row)"></el-button></el-col>
          </el-row>
        </template>
      </el-table-column>
    </el-table>
    <div class = "pagination">
      <el-pagination
        background
        @current-change="changePage"
        layout="prev, pager, next, total"
        :page-size="limit"
        :current-page="currentPage"
        :total="total">
      </el-pagination>
    </div>
    <div>
      <el-dialog title="得意先変更" v-if="outerVisible" :visible.sync="outerVisible" :before-close="handleClose">
        <modify :userDtil="userDtil" v-bind:outerVisible="outerVisible" v-on:activeNameChg="activeChg($event)"></modify>
      </el-dialog>
    </div>
    <div style="margin-top: 1em;padding-left: 91%;">
        <el-button type="danger" class="btn-left" @click.native.prevent="clean()"><i class="el-icon-caret-right"style="color: white;"></i> 戻　る </el-button>
    </div>
  </el-form>
</template>

<script>
  import http from '../../assets/js/http'
  import { isNumber } from '../../assets/js/check'
  import _g from '../../assets/js/global'
  import modify from '../shanaikanrisha/modify'

  export default {
    data() {
      var number = (rule, value, callback) => {
        if (value !== null && value !== '') {
          if (!isNumber(value)) {
            callback(new Error('電話番号を正しく入力してください。'))
          } else {
            callback()
          }
        } else {
          callback()
        }
      }
      return {
        form1: {
          clientId: '',
          company_name: '',
          number: ''
        },
        userDtil: [],
        limit: 20,
        isShow: false,
        outerVisible: false,
        currentPage: null,
        loading: false,
        total: null,
        tableData: [],
        tableDataExcel: [],
        rules1: {
          number: [
            { validator: number, trigger: 'blur' }
          ]
        }
      }
    },
    methods: {
      search(form1) {
        this.loading = false
        this.$refs[form1].validate((valid) => {
          if (valid) {
            this.currentPage = 1
            this.getAllUsers(true)
            this.$router.push({
              path: this.$route.path,
              query: { userId: this.userId, clientId: this.form1.clientId, company_name: this.form1.company_name, number: this.form1.number, currentPage: this.currentPage }
            })
          } else {
            return false
          }
        })
      },
      clientList(fileName) {
        import('../../vendor/Export2Excel').then(excel => {
          const tHeader = ['得意先コード', '会社名', '担当者', 'メールアドレス', '電話番号']
          const filterVal = ['client_id', 'company_name', 'name', 'mail_address', 'tel']
          const list = this.tableDataExcel
          const data = this.formatJson(filterVal, list)
          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: fileName,
            autoWidth: true
          })
        })
      },
      formatJson(filterVal, jsonData) {
        return jsonData.map(v => filterVal.map(j => {
          if (j === 'timestamp') {
            return parseTime(v[j])
          } else {
            return v[j]
          }
        }))
      },
      handleEdit(index, row) {
        this.userDtil = row
        this.outerVisible = true
      },
      handleDelete(index, row) {
        this.$confirm('この得意先を削除してよろしいですか?', '', {
          confirmButtonText: 'はい',
          cancelButtonText: 'いいえ',
          type: 'warning'
        }).then(() => {
          var userId = window.localStorage.getItem('userId')
          let data = {}
          data.clientId = row['client_id']
          data.userId = userId
          this.apiPost('shanaikanrisha/ClientList/delete', data).then((res) => {
            this.handelResponse(res, (data) => {
              if (res.code != 200) {
                this.handleError(res)
              } else {
                this.$message({
                  type: 'success',
                  message: '削除しました!'
                })
                this.getAllUsers(true)
              }
            })
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'キャンセル'
          })
        })
      },
      excle(form1) {
        this.$refs[form1].validate((valid) => {
          if (valid) {
            this.loading = true
            let data = {}
            data.clientId = this.form1.clientId
            data.company_name = this.form1.company_name
            data.number = this.form1.number
            this.apiPost('shanaikanrisha/ClientList/clientList', data).then((res) => {
              this.handelResponse(res, (data) => {
                if (res.code != 200) {
                  this.tableData = []
                  this.total = null
                  this.handleError(res)
                } else {
                  this.loading = false
                  let dataList1
                  if (data.list) {
                    if (data.list.constructor == Array) {
                      dataList1 = data.list
                      var a = data.list.forEach(function (item, index, input) {
                        dataList1[index].name = item.contact_name_sei + ' ' + item.contact_name_mei
                        dataList1[index].tel = item.companytel_siban + '-' + item.companytel_kaiban + '-' + item.companytel_kyokuban
                      })
                    } else {
                      data.list.name = data.list.contact_name_sei + ' ' + data.list.contact_name_mei
                      data.list.tel = data.list.companytel_siban + '-' + data.list.companytel_kaiban + '-' + data.list.companytel_kyokuban
                      dataList1 = [data.list]
                    }
                    this.tableDataExcel = dataList1
                    this.clientList('社内向け得意先情報一覧')
                    this.search(form1)
                  }
                }
              })
            })
          }
        })
      },
      getAllUsers(flg) {
        let data = {}
        if (flg) {
          data.clientId = this.form1.clientId
          data.company_name = this.form1.company_name
          data.number = this.form1.number
        }
        data.page = this.currentPage
        data.limit = this.limit
        this.apiPost('shanaikanrisha/ClientList/clientList', data).then((res) => {
          this.handelResponse(res, (data) => {
            if (res.code != 200) {
              this.tableData = []
              this.total = null
              this.handleError(res)
            } else {
              let dataList1
              if (data.list) {
                if (data.list.constructor == Array) {
                  dataList1 = data.list
                  var a = data.list.forEach(function (item, index, input) {
                    dataList1[index].name = item.contact_name_sei + ' ' + item.contact_name_mei
                    dataList1[index].tel = item.companytel_siban + '-' + item.companytel_kaiban + '-' + item.companytel_kyokuban
                  })
                } else {
                  data.list.name = data.list.contact_name_sei + ' ' + data.list.contact_name_mei
                  data.list.tel = data.list.companytel_siban + '-' + data.list.companytel_kaiban + '-' + data.list.companytel_kyokuban
                  dataList1 = [data.list]
                }
                this.tableData = dataList1
                this.total = data.dataCount
              }
            }
          })
        })
      },
      getCurrentPage() {
        let data = this.$route.query
        if (data) {
          if (data.currentPage) {
            this.currentPage = parseInt(data.currentPage)
          } else {
            this.currentPage = 1
          }
        }
      },
      getKeywords() {
        let data = this.$route.query
        if (data) {
          if (data.userId) {
            this.userId = data.userId
          } else {
            this.userId = ''
          }
        }
      },
      changePage(currentPage) {
        this.currentPage = currentPage
        // this.getCurrentPage
        this.getAllUsers(true)
        this.$router.push({
          path: this.$route.path,
          query: { userId: this.userId, clientId: this.form1.clientId, company_name: this.form1.company_name, number: this.form1.number, currentPage: currentPage }
        })
      },
      handleClose(done) {
        this.$confirm('この画面を閉じますか？')
          .then(_ => {
            done()
          })
          .catch(_ => {})
      },
      clean() {
        window.localStorage.setItem('userId', '')
        window.localStorage.setItem('loginRoot', '')
        this.resetCommonData('/shanaikanrisha/login')
        _g.toastMsg('warning', 'ログアウトしました！')
      },
      activeChg(chg) {
        this.outerVisible = chg
        this.getAllUsers(true)
      }
    },
    mounted() {
      window.addEventListener('keyup', (e) => {
        if (e.keyCode === 13) {
          return false
        }
      })
    },
    created() {
      this.getKeywords()
      this.getCurrentPage()
      this.getAllUsers(false)
    },
    components: {
      modify
    },
    mixins: [http]
  }
</script>
<style>
  .btn-left{
    float: right;
    width: 8em;
  }
  .pagination{
    width: 100%;
    text-align:center;
  }
  .el-dialog {
    width: 55em
  }
</style>



// WEBPACK FOOTER //
// src/components/shanaikanrisha/searchList.vue